import { render, staticRenderFns } from "./CoreCookieBanner.vue?vue&type=template&id=d4d613e8&scoped=true&"
import script from "./CoreCookieBanner.vue?vue&type=script&setup=true&lang=ts&"
export * from "./CoreCookieBanner.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./CoreCookieBanner.vue?vue&type=style&index=0&id=d4d613e8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d4d613e8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/prodoctorov/pd-ssr/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d4d613e8')) {
      api.createRecord('d4d613e8', component.options)
    } else {
      api.reload('d4d613e8', component.options)
    }
    module.hot.accept("./CoreCookieBanner.vue?vue&type=template&id=d4d613e8&scoped=true&", function () {
      api.rerender('d4d613e8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/layouts/core-layout/components/CoreCookieBanner/CoreCookieBanner.vue"
export default component.exports